/**
 * Enum for specifying how events data should be fetched
 */
export enum EventsDataFetchingMode {
  /**
   * Fetch events using per-game time ranges (default)
   * Each game has its own time range resolved from calendar or fallback dates
   */
  PerGame = 'perGame',
  /**
   * Fetch events using eventCalendar time range for all games
   * All games share the same time range from the eventCalendar
   */
  EventCalendar = 'eventCalendar',
  /**
   * Fetch events for Live Event Feed tab
   * Uses fallbackDateFrom and fallbackDateTo directly without buffering or adjustment
   */
  Feed = 'feed',
  /**
   * Fetch events for Event Statistics tab
   * Uses useDefaultLiveEvents hook with default time ranges
   */
  EventStats = 'eventStats',
}
